import React from 'react';
import Icon from '../Icon';
import classNames from '../../utility/classNames';

export default function DropdownButtonComponent({
  isOpen,
  setOpen,
  text = null,
  textStyles = null,
  buttonStyles = null,
  mobileTextVis = 'hidden',
}) {
  return (
    <button
      type="button"
      className={classNames(
        'transition border border-transparent flex items-center justify-center gap-2 p-1 rounded-md outline-none text-base tracking-wide text-black  hover:bg-neutral-50 hover:text-primary focus:border-neutral-900 disabled:opacity-50 disabled:cursor-not-allowed peer -mt-1',
        buttonStyles
      )}
      onClick={() => setOpen(!isOpen)}
    >
      {isOpen ? (
        <>
          {text ? (
            <span
              className={classNames(
                mobileTextVis,
                'min-w-[50px] sm:inline text-left whitespace-nowrap',
                textStyles
              )}
            >
              {text.isOpen}
            </span>
          ) : (
            <span className="sr-only">Close</span>
          )}
        </>
      ) : (
        <>
          {text ? (
            <span
              className={classNames(
                mobileTextVis,
                'sm:inline pr-1 min-w-[60px] lg:min-w-[50px] text-left whitespace-nowrap',
                textStyles
              )}
            >
              {text.isClosed}
            </span>
          ) : (
            <span className="sr-only">Open</span>
          )}
        </>
      )}
      <Icon
        icon="FiChevronDown"
        className={classNames(
          'transition h-4 w-4  -mb-0.2',
          isOpen && 'rotate-180'
        )}
        aria-hidden="true"
      />
    </button>
  );
}
